import { ApiService } from "../api.service";
import { ActivatedRoute, Router } from "@angular/router";
import { CommonService } from "../common.service";
var CasePracticeTeamComponent = (function () {
    function CasePracticeTeamComponent(apiService, route, router, commonService) {
        this.apiService = apiService;
        this.route = route;
        this.router = router;
        this.commonService = commonService;
        this.isPC = false;
    }
    CasePracticeTeamComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.queryParams.subscribe(function (queryParams) {
            _this.type = queryParams['type'];
            if (_this.type) {
                localStorage.setItem('isPC', _this.type);
            }
        });
        this.route.params.subscribe(function (params) {
            console.log(params);
            _this.practiceMetaId = params['practiceMetaId'];
            _this.learningPathId = params['learningPathId'];
            _this.methodId = params['methodId'];
            _this.isPC = !!localStorage.getItem('isPC');
            if (localStorage.getItem('isIframe')) {
                _this.goToNextStep(1);
            }
            else if (_this.methodId == 1) {
                _this.page = 'list';
            }
            else if (_this.methodId == 2) {
                _this.page = 'video';
                _this.pageToVideo = 'begin';
                _this.multiExerciseMetaId = params['multiExerciseMetaId'];
            }
            else if (_this.methodId == 3) {
                //新增特殊场景
                _this.page = 'video';
                _this.pageToVideo = 'begin';
                _this.showCloseBtn = true;
                _this.multiExerciseMetaId = params['multiExerciseMetaId'];
            }
        });
        setTimeout(function () {
            if (_this.type) {
                $('#userIdContainer').val(JSON.parse(localStorage.getItem('userInfo'))['userId']);
            }
        }, 500);
    };
    CasePracticeTeamComponent.prototype.goToVideo = function (page) {
        this.page = 'video';
        this.pageToVideo = page;
    };
    CasePracticeTeamComponent.prototype.goToQuestion = function () {
        this.page = 'question';
    };
    CasePracticeTeamComponent.prototype.goToBegin = function () {
        var link = ['case-practice-team-begin', this.multiExerciseMetaId, this.learningPathId, this.practiceMetaId];
        if (this.type) {
            this.router.navigate(link, { queryParams: { type: 'huatek' } });
        }
        else {
            this.router.navigate(link);
        }
    };
    CasePracticeTeamComponent.prototype.goToMain = function (typeId) {
        var link = ['case-practice-team-main', typeId, this.learningPathId, this.practiceMetaId];
        if (this.type) {
            this.router.navigate(link, { queryParams: { type: 'huatek' } });
        }
        else {
            this.router.navigate(link);
        }
    };
    CasePracticeTeamComponent.prototype.goToNextStep = function (step) {
        var _this = this;
        if (step == 1) {
            this.page = 'video';
        }
        else if (step == 2) {
            this.page = 'question';
        }
        else if (step == 3) {
            this.route.params.subscribe(function (params) {
                if (_this.type === 'huatek') {
                    _this.multiExerciseMetaId = 1;
                }
                var link = ['case-practice-team-begin', _this.multiExerciseMetaId, _this.learningPathId, _this.practiceMetaId];
                if (_this.type) {
                    _this.router.navigate(link, { queryParams: { type: 'huatek' } });
                }
                else {
                    _this.router.navigate(link);
                }
            });
            var exerciseMetaId = $('#exerciseMetaId').val();
            this.apiService.learingTime({ learningPathMetaId: localStorage.getItem("learningPathMetaId"), module: '情景模拟', courseUnit: '', type: 1, btnName: '41', userId: localStorage.getItem("userId") }).subscribe(function (result) {
                console.log(result);
            });
            console.log(exerciseMetaId);
            this.commonService.sendPostMessage(0, 'isPractice' + 'Complete');
        }
    };
    CasePracticeTeamComponent.prototype.setMultiExerciseMetaId = function (id) {
        this.multiExerciseMetaId = id;
    };
    return CasePracticeTeamComponent;
}());
export { CasePracticeTeamComponent };



// WEBPACK FOOTER //
// ./src/app/case-practice-team/case-practice-team.component.ts.pre-build-optimizer.js